import React, { FC } from 'react';
import { useObserver } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';

import { saveStepAndGoToCustomizeErWithPsk } from '../../custom-kit/CustomizeRedirector';
import { useRootStore } from '../../../../root/RootStoreHooks';

interface Props {
  isSelected: boolean;
  selectCustomizeKitWithPsk: () => void;
}

const HeaderCustom: FC<Props> = ({ isSelected, selectCustomizeKitWithPsk }) => {
  const store = useRootStore();

  function handleClick() {
    selectCustomizeKitWithPsk();
    saveStepAndGoToCustomizeErWithPsk(store);
  }

  return (
    <div className={`text-right ${isSelected ? 'bg-primary' : 'bg-secondary'}`} onClick={() => handleClick()}>
      <div className="container-checkbox-popular">
        <input type="checkbox" readOnly checked={isSelected} />
        <span className="checkmark-basic" />
        <p className="text-white pr-2 pt-2">0.00</p>
      </div>
    </div>
  );
};

interface ItemProps {
  customKitWithPskSelected: boolean;
  selectCustomizeKitWithPsk: () => void;
}

export const KitGridItemCustomPsk: FC<ItemProps> = ({ customKitWithPskSelected, selectCustomizeKitWithPsk }) => {
  const { t } = useTranslation();
  const store = useRootStore();

  function handleClick() {
    selectCustomizeKitWithPsk();
    saveStepAndGoToCustomizeErWithPsk(store);
  }

  return useObserver(() => (
    <>
      <p className="text-center">{t('PremiumStarterKits')}</p>
      <div className="card">
        <HeaderCustom isSelected={customKitWithPskSelected} selectCustomizeKitWithPsk={selectCustomizeKitWithPsk} />
        <div className="card-body text-center card-text">
          <span>
            <Button variant="link">
              <Image src="https://static.youngliving.com/productimages/large/StarterKitAsErImage.jpg" alt="" fluid />
            </Button>
          </span>
          <div className="d-flex flex-row flex-column">
            <span>{t('AddStarterKitToErInstructions')}</span>
            <Button variant="primary" onClick={() => handleClick()}>
              {t('ViewAll')}
            </Button>
          </div>
        </div>
      </div>
    </>
  ));
};
